
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import PageRequest from '@/store/entities/page-request';

class  PageRequestSelection extends PageRequest{
    keyword: string;
    from: Date;
    to: Date;
}

@Component
export default class TenantSelectionList extends AbpBase{
    @Prop({type: Number, default: 0}) value: number;
    @Prop({type: Number, default: 0}) index: number;
    @Prop({type: Boolean, default: false}) disabled: boolean;
    @Prop({type: String, default: ''}) placeholder: string;
    @Prop({type: Boolean, default: false}) clearable: boolean;

    pagerequest: PageRequestSelection = new PageRequestSelection();

    get newValue(){
        return this.value;
    }
    set newValue(value:Number){
        this.$emit('input', value);
    }
    get list(){
        let list = this.$store.state.tenant.list;
        return list;
    }
    change(item: any) {
        this.$emit("on-change", this.index, item);
    }
    async queryChange(item: any){
       this.pagerequest.keyword = item;
       await this.$store.dispatch({
            type:'tenant/getAll',
            data:this.pagerequest
        });
    }
    async created(){
        await this.$store.dispatch({
            type:'tenant/getAll',
            data:this.pagerequest
        });
    }
}
